import { Alert, AlertTitle, Box, Button, Stack, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { ToBeSaved } from "lib/@components/save-indicator/save-indicator"
import { useState } from "react"
import { ScheduleTopmost } from "routes/schedule/scheduleIntroduction"
import Iconify from "minimals-template/components/Iconify"
import { Switch, Case, If } from "lib/@components/switch"

export function SaveWarning({ id = "schedule", onRetry = undefined, displayBanner = true, slot = ScheduleTopmost }) {
    const { editMode } = useBoundContext()
    const [saveState, setSaveState] = useState(null)

    ToBeSaved(id).useEvent(
        (value) => {
            if (value instanceof Error && value.message.startsWith("Deferring")) {
                setSaveState(null)
                return
            }
            if (value === "queued") setSaveState("queued")
            else if (value instanceof Error && value.message !== "Conflict") setSaveState("error")
            else setSaveState(null)
        },
        [id]
    )

    if (!displayBanner || !editMode || !saveState) return null

    const content = (
        <Box sx={{ position: "sticky", top: 0, zIndex: 1200 }}>
            <Switch value={saveState}>
                <Case when="queued">
                    <Alert
                        icon={<Iconify icon="mdi:cloud-sync-outline" />}
                        severity="info"
                        data-cy="schedule-save-warning"
                        sx={{ my: 2 }}
                    >
                        <AlertTitle>Changes saved locally</AlertTitle>
                        <Typography variant="body2">
                            Your changes are stored on this device and waiting to sync to the server automatically.
                        </Typography>
                    </Alert>
                </Case>
                <Case when="error">
                    <Alert
                        icon={<Iconify icon="mdi:content-save-alert" />}
                        severity="error"
                        data-cy="schedule-save-error"
                        sx={{ my: 2, boxShadow: 3 }}
                    >
                        <Stack spacing={1}>
                            <AlertTitle>Save failed</AlertTitle>
                            <Typography variant="body2">
                                Your changes could not be saved. Please check your connection and try again.
                            </Typography>
                            <If value={onRetry}>
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <Button
                                        onClick={onRetry}
                                        size="small"
                                        variant="contained"
                                        startIcon={<Iconify icon="mdi:content-save" />}
                                    >
                                        Retry save
                                    </Button>
                                </Stack>
                            </If>
                        </Stack>
                    </Alert>
                </Case>
            </Switch>
        </Box>
    )

    if (!slot) return content
    const Slot = slot

    return <Slot.Plug>{content}</Slot.Plug>
}
